// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7728) return "static/chunks/7728-1708f95bdfbcfd29.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "542b43ce8f739f92" + ".js";
};